import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

const CategoryPage = [
    // Breadcrumb navigation
    {
        span: 12,
        height: "20px",
        classes: "marginBottom-16 mTop-16",
    },

    // Page title
    {
        span: 8,
        height: "32px",
        classes: "marginBottom-16",
    },

    // Category cards row (3 horizontal blocks with 16px gap)
    {
        classes: "marginTop-32 marginBottom-40 flex",
        columns: [
            {
                height: "240px",
                span: 12,
                classes: "marginRight-16",
            },
            {
                height: "240px",
                span: 12,
                classes: "marginRight-16",
            },
            {
                height: "240px",
                span: 12,
                classes: "",
            },
        ],
    },
]

const CategoryPageSkeleton = () => {
    return (
        <div className="page-container container-fluid">
            <Skeleton config={CategoryPage} />
        </div>
    )
}

export default CategoryPageSkeleton
